var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_10_1",
    "data-name": "Component 10 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(-926 -959)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(969.673 982.102) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1550",
    "data-name": "Rectangle 1550",
    width: 3.09,
    height: 3.09,
    transform: "translate(11.032)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1551",
    "data-name": "Rectangle 1551",
    width: 3.09,
    height: 3.09,
    transform: "translate(11.032 15.509)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1552",
    "data-name": "Rectangle 1552",
    width: 3.09,
    height: 3.09,
    transform: "translate(14.91 3.876)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1553",
    "data-name": "Rectangle 1553",
    width: 3.09,
    height: 3.09,
    transform: "translate(14.91 11.632)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1554",
    "data-name": "Rectangle 1554",
    width: 3.088,
    height: 3.088,
    transform: "translate(18.791 7.756)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1555",
    "data-name": "Rectangle 1555",
    width: 3.09,
    height: 3.09,
    transform: "translate(0 15.509)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 3.09,
    height: 3.09,
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    width: 3.09,
    height: 3.09,
    transform: "translate(3.877 11.632)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1558",
    "data-name": "Rectangle 1558",
    width: 3.09,
    height: 3.09,
    transform: "translate(3.877 3.876)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    width: 3.088,
    height: 3.088,
    transform: "translate(7.759 7.756)",
    fill: "#090909"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(926 959)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.9f17ab23.svg";
export { ForwardRef as ReactComponent };